<div class="order-error-page">
  <main class="error-main">
    <div class="error-content">
      <div class="error-icon-container">
        <div class="error-icon">
          <span class="mdn-Icon-circulo-exclamacao mdn-Icon--lg" [attr.aria-label]="'pages.orderError.iconAlt' | i18n"></span>
        </div>
      </div>

      <h1 class="error-title">{{ 'pages.orderError.title' | i18n }}</h1>

      <div class="error-message">
        <p>{{ 'pages.orderError.message1' | i18n }}</p>
        <p>{{ 'pages.orderError.message2' | i18n }}</p>
      </div>

      <div class="action-buttons">
        <ustore-button 
          [text]="'pages.orderError.backToCart' | i18n" 
          [format]="'filled'" 
          [backgroundColor]="'var(--color-red-500-to-yellow)'" 
          [textColor]="'var(--color-inverted)'" 
          [size]="'medium'" 
          [rounded]="'default'" 
          (click)="goToCheckout()" 
          class="primary-button">
        </ustore-button>
      </div>
    </div>
  </main>
</div>